import React from 'react';
import styled from '@emotion/styled';
import BannerStrip from '../../../components/BannerStrip/BannerStrip';
import { TRACK } from '../../../routes/routeConstants';

const Hero = () => {
  return (
   <Container>
    <WrapImage
     className='web'
     src='/static/img/cml/partner_hero_bg.png'
     alt='hero image'
    />
    <WrapImage
     className='mobile'
     src='/static/img/cml/partner_hero_bg.png'
     alt='hero image'
    />
    <Top>
     <BannerStrip
      text='Track parcels from top eCommerce retailers directly to your doorstep.'
      btnText='Track'
      link={`/${TRACK}`}
     />
    </Top>
    <Content>
     <TextSection>
      <Heading>
       Shop easily from top UK, US, and global stores and get your orders
       <br /> <span> delivered to Nigeria</span>
      </Heading>
     </TextSection>

     <ImageWrapper>
      <Image src='/static/img/cml/global_imports_hero.png' alt='truck' />
      <MobileImage src='/static/img/cml/global_imports_hero.png' alt='truck' />
     </ImageWrapper>
    </Content>
   </Container>
  );
};

export default Hero;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: -1rem -5.4375rem 0;
  padding: 3rem 5.4375rem;
  position: relative;
  overflow: hidden;

  width: 100vw;
  min-height: calc(100vh - 80px);

  @media (max-width: 884px) {
    padding: 0;
    margin: 0 -24px;
    min-height: calc(100vh - 60px);
  }
`;

const WrapImage = styled.img`
  object-fit: cover;
  position: absolute;
  top:0;
  bottom:0;
  left:0;
  right:0;

  &.mobile {
    display: none;
  }

  @media (max-width: 884px) {
    &.web {
      display: none;
    }

    &.mobile {
      display: block;
      object-fit: cover;
      object-position: center center;
    }
  }

  @media (max-width: 480px) {
    &.mobile {
      display: block;
      object-fit: cover;
      height: 100%;
      width: 100%;
    }
  }
`;

const Top = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
`;

const Content = styled.section`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  gap: 48px;
   z-index: 200;

  @media (max-width: 1280px) {
  width: 100%;
  margin-top: 4rem !important;
  }

  @media (max-width: 884px) {
  width: 100%;
  margin-top: 4rem !important;
  padding: 0px 24px;
    grid-template-columns: 1fr;
    place-items: center;
    text-align: center;
  }
`;

const TextSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  button{
  width: fit-content}

  @media (max-width: 884px) {
    gap: 16px;
    align-items: center;
  }
`;

const Heading = styled.h1`
  font-size: 58px;
  font-weight: 800;
  line-height: 1.2; 
  color: #000;

  span {
    color: ${({ theme }) => theme.palette.redFontColor}; /* red shade */
  }

  @media (max-width: 884px) {
    font-size: 28px;
  }
`;


const ImageWrapper = styled.div`
  width: 100%;
  max-width: 600px;
  border-radius: 16px;
  overflow: hidden;

  @media (max-width: 884px) {
    max-width: 100%;
  }
`;

const Image = styled.img`
  width: 100%;
  height: auto;
  display: block;
  border-radius: 16px;

  @media (max-width: 884px) {
    display: none;
  }
`;

const MobileImage = styled.img`
  width: 100%;
  height: auto;
  display: none;
  border-radius: 16px;

  @media (max-width: 884px) {
    display: block;
  }
`;

